import { getBottomBannerOffset, useBottomBanners } from "context/BottomBannersContext";

export function useBottomBannerOffset(): number {
  return getBottomBannerOffset(useBottomBanners());
}
